import LastAuthenticationSuccessEvent from './lastauthenticationsuccessevent'

export default LastAuthenticationSuccessEvent